import { gql } from '@apollo/client';
import moment from 'moment';
import { ListData } from './types';

const getDaysAgo = (date: number) => {
  // strip out times to properly calculate day difference
  const currentDate = moment().startOf('day');
  const pastDate = moment(date).startOf('day');
  return currentDate.diff(pastDate, 'days');
};

export const parseListOption = ({ id, name, updatedAt }: ListData) => ({
  id: `${name}-${id}`,
  label: name,
  doubleLine: `List ID: ${id} | Updated ${getDaysAgo(updatedAt ?? 0)} days ago`,
  value: `${id}`,
});

export const fetchListsQuery = gql`
  query getLists($filterInfo: ListFilterInfoInput, $search: String, $sort: Sort) {
    lists(
      filterInfo: $filterInfo
      pagination: { limit: 25, offset: 0 }
      search: $search
      sort: $sort
    ) {
      results {
        id
        name
        updatedAt
      }
    }
  }
`;
